import { Action } from "redux";

import {
  GET_PACKAGE_PRICING,
  GET_MESSAGES,
  GET_EVENT_IMAGE,
  IS_LOADING,
  GET_EVENT,
} from "./types";
import { MessagesType } from "../../../models";

type AppAction = {
  type:
    | "GET_MESSAGES"
    | "GET_PACKAGE_PRICING"
    | "IS_LOADING"
    | "GET_EVENT_IMAGE"
    | "GET_EVENT";
  payload: any;
};

const initialState = {
  event: null,
  packagePricing: null,
  eventImages: null,
  messages: null,
  loading: false,
};

export default (state = initialState, action: AppAction) => {
  switch (action.type) {
    case GET_MESSAGES:
      return {
        ...state,
        messages: action.payload,
      };
    case GET_PACKAGE_PRICING:
      return {
        ...state,
        packagePricing: action.payload,
      };
    case GET_EVENT_IMAGE:
      return {
        ...state,
        eventImages: action.payload,
      };
    case GET_EVENT:
      return {
        ...state,
        event: action.payload,
      };
    case IS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    default:
      return state;
  }
};
